<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-v-component
          heading="Список договоров"
        />
        <base-material-card
          color="primary"
          icon="mdi-file-document"
          inline
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Договора
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search.sync="search"
              multi-sort
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="3">
                        <v-text-field
                          v-model="form.date.from"
                          label="Дата начала"
                          type="date"
                          @keyup.enter="load"
                        />
                      </v-col>
                      <v-col cols="3">
                        <v-text-field
                          v-model="form.date.to"
                          label="Дата конца"
                          type="date"
                          @keyup.enter="load"
                        />
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          color="primary"
                          dark
                          class="mb-2"
                          @click="load"
                        >
                          Поиск
                        </v-btn>
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          color="secondary"
                          dark
                          min-width="250"
                          class="mb-2"
                          @click="clear"
                        >
                          Сбросить фильтры
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon
                  v-if="$store.state.access[4][3] || $store.state.access[4][4] && item.creator && item.creator.id == $store.state.user.id"
                  large
                  color="primary"
                  class="mr-2"
                  @click="$router.push('/contract/view?id=' + item.id)"
                >
                  mdi-cog
                </v-icon>
                <v-icon
                  v-else
                  large
                  color="primary"
                  class="mr-2"
                  @click="$router.push('/contract/view?id=' + item.id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <template v-slot:item.date="{ item }">
                {{ format_date(item.date) }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="$store.state.access[4][5]"
              color="primary"
              min-width="100"
              @click="$router.push('/contract/create')"
            >
              Создать
            </v-btn>
          </v-card-actions>
        </base-material-card>
        <v-bottom-sheet v-model="sheet">
          <v-list>
            <v-list-group v-model="sheetmenu">
              <v-list-tile slot="activator">
                <v-list-tile-action>
                  <v-icon>mdi-build</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Действия</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-item @click="$router.push('/contract/change?id=' + sheetitem.id)">
                <v-list-item-content>
                  Изменить договор
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="$router.push('/contract/view?id=' + sheetitem.id)">
                <v-list-item-content>
                  Открыть договор
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-bottom-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.table_item {
  font-size: 0.929rem;
  padding-bottom: 12px;
}
.table_item:first-of-type {
  padding-top: 12px;
}

.table_item__title {
  font-size: 0.929rem;
}
.table_item__subtitle{
  font-size: 0.875rem;
  line-height: 1.2;
  color: #999;
}
</style>
<script>
  import suggest from '../../libs/suggestions.min.17.12.0.dev.js'
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      sheet: false,
      sheetmenu: true,
      headers: [
        {
          sortable: false,
          text: 'Действия',
          value: 'action',
        },
        {
          text: 'Номер',
          value: 'number',
        },
        {
          text: 'Дата',
          value: 'date',
        },
      ],
      items: [],
      form: {
        date: {
          from: '',
          to: '',
        },
      },
      select: {
      },
      dict: {
      },
    }),
    mounted: function () {
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
      var store_filters = JSON.parse(localStorage.getItem('contract_filters'))
      if (store_filters) {
        if (store_filters.date) {
          if (store_filters.date.from) {
            this.form.date.from = store_filters.date.from
          }
          if (store_filters.date.to) {
            this.form.date.to = store_filters.date.to
          }
        }
      }
      if (this.$route.query.id) {
        this.form.id = this.$route.query.id
      }
      this.axios.post('/api/user/get/', { deleted: false })
        .then(response => {
          if (!response.data.error) {
            this.select.users = response.data.data
          } else {
            // this.$store.commit('snackbar', response.data.data || 'Ошибка при получении данных')
          }
        })
        .catch(e => {
          this.$store.commit('snackbar', 'Ошибка при получении данных')
        })
      this.load()
    },
    methods: {
      format_date: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      getDoc: function (item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      clear: function () {
        this.form = {
          date: {
            from: '',
            to: '',
          }
        },
        this.form.date.from = moment().format('YYYY-MM-DD')
        this.form.date.to = moment().format('YYYY-MM-DD')
        this.load()
      },
      load: function (clear) {
        localStorage.setItem('contract_filters', JSON.stringify(this.form))
        this.axios.post('/api/contract/get', this.form)
          .then(result => {
            this.form.id = null
            if (!result.data.error) {
              this.items = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
